import { render, staticRenderFns } from "./shareDrawer.vue?vue&type=template&id=6083dbda&scoped=true"
import script from "./shareDrawer.vue?vue&type=script&lang=js"
export * from "./shareDrawer.vue?vue&type=script&lang=js"
import style0 from "./shareDrawer.vue?vue&type=style&index=0&id=6083dbda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6083dbda",
  null
  
)

export default component.exports